import { isObject } from 'lodash';

/**
 * Attempt to cast a raw bson type to something we can do a comparison with.
 * Does not attempt to cast primitive values (ie non-objects)
 * @param {Object|Primitive} value - raw bson type or primitive
 * @returns {Primitive} - a primitive, orderable type
 */
function attemptCast(value) {
  if (!isObject(value)) {
    return value;
  }

  const { _bsontype: bsonType } = value;
  if (bsonType === 'Decimal128') {
    return parseFloat(value.toString());
  } else if (bsonType) {
    return JSON.stringify(value);
  }

  return value;
}

/**
 * Convert given bson type alias to its corresponding type that's
 * used when inferring field type and field filters.
 *
 * @param {String} alias bson type alias
 * @returns {string} corresponding bson type name
 */
function bsonAliasToType(alias) {
  switch (alias) {
    case 'string':
      return 'String';
    case 'date':
      return 'Date';
    case 'double':
      return 'Double';
    case 'bool':
      return 'Boolean';
    default:
      throw new Error('Unknown alias: ' + alias);
  }
}

export { attemptCast, bsonAliasToType };
